import src from "IMAGE";
export default { src, width: 241, height: 61, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ADtckfdKZ5j6RmSU+jtTb/pEV2j6Rlhn+kNWafpVY2nzACtSjP1Mapv/QGCT/zJPdP87U23/QVZr/0haaP9MX275PcghMMFGYzwAAAAASUVORK5CYII="};
